import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class DossierTypesService {
    // ----------------------------------------------------------------------
    // Dossier Types
    // ----------------------------------------------------------------------
    static getDossierTypes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`dossier-types?filter=${qs}`, pageNumber));
    }
    // public static fetchDossierType(oid: number) {
    //   return BaseService.get<IDossierType>(`dossier-types/${oid}`);
    // }
    static saveDossierType(dto) {
        return lastValueFrom(BaseService.save(`dossier-types`, dto));
    }
    static deleteDossierType(oid) {
        return lastValueFrom(BaseService.delete(`dossier-types/${oid}`));
    }
    static searchDossierTypeCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`dossier-types-combo/${selfId}?search=${qs}`));
    }
}
